import React from 'react';
import { ASSETS } from '../assetManifest.js';

const GameHeader = ({ coins, keys, coinsPerSecond, coinAnimation }) => {
  return (
    <header className="flex justify-between items-center mb-4 p-4 rounded-xl bg-black/20 backdrop-blur-sm border-b border-white/10 flex-shrink-0">
      <div>
        <h1 className="text-2xl sm:text-4xl font-mono font-bold bg-gradient-to-r from-blue-300 via-purple-300 to-pink-300 bg-clip-text text-transparent tracking-wider">
          Dragon Collector
        </h1>
        <p className="text-xs text-gray-400 mt-1 font-sans">An epic journey of collection and breeding</p>
      </div>
      <div className="flex items-center space-x-6">
        <div className="text-right">
          <div className={`flex items-center justify-end space-x-2 text-lg sm:text-xl transition-all duration-300 ${coinAnimation ? 'scale-110 text-yellow-300' : 'text-yellow-400'}`}>
            <img src={ASSETS.icons.coin.path} alt="Coins" className="w-6 h-6 sm:w-7 sm:h-7" />
            <span className="font-bold font-sans">{Math.floor(coins).toLocaleString()}</span>
          </div>
          {coinsPerSecond > 0 && (
            <p className="text-xs text-green-400 mt-1 text-right font-sans">
              +{coinsPerSecond.toLocaleString()}/sec
            </p>
          )}
        </div>
        <div className="flex items-center space-x-2 text-lg sm:text-xl text-purple-400">
          <span className="text-2xl">🗝️</span>
          <span className="font-bold font-sans">{keys}</span>
        </div>
      </div>
    </header>
  );
};

export default GameHeader;
